import { isLEHotel } from 'lib/offer/offerTypes'

export function isFlightForceBundled(offer?: App.AnyOffer) {
  return !!offer && isLEHotel(offer) && (!!offer.bundledWithFlightsOnly || !!offer.forceBundleId)
}
